var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "h-100",
      class: { "pt-5": _vm.resultPage.isMobile === true },
    },
    [
      _c("div", { staticClass: "h-100" }, [
        _c(
          "div",
          { staticClass: "gallery-1 justify-content-center pb-20 h-100" },
          [
            _vm.loading
              ? _c("div", { staticClass: "placeholder" }, [
                  _c("div", { staticClass: "animated-background" }),
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.complete === true
              ? _c("div", { staticClass: "container" }, [
                  _vm.output_too_large === true
                    ? _c("div", { staticClass: "alert alert-info" }, [
                        _vm._v(
                          "\n          " +
                            _vm._s(
                              _vm._f("trans")("File is too large for preview")
                            ) +
                            "\n        "
                        ),
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.output_failed === true
                    ? _c("div", { staticClass: "alert alert-warning" }, [
                        _vm._v(
                          "\n          " +
                            _vm._s(
                              _vm._f("trans")("Could not get file for preview")
                            ) +
                            "\n        "
                        ),
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.output_too_large === false && _vm.output_failed === false
                    ? _c("div", { staticClass: "card" }, [
                        _c(
                          "div",
                          { staticClass: "card-header font-weight-bold" },
                          [
                            _vm._v(
                              _vm._s(_vm._f("trans")("Your generated hash"))
                            ),
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "card-body p-3 text-output" },
                          [
                            _c("div", { staticClass: "bg-hash p-3 br-8" }, [
                              _c("p", { staticClass: "font-weight-bold" }, [
                                _vm._v("hex: " + _vm._s(_vm.output_content)),
                              ]),
                              _vm._v(" "),
                              _c("p", [
                                _vm._v(
                                  "HEX: " +
                                    _vm._s(_vm.output_content.toUpperCase())
                                ),
                              ]),
                              _vm._v(" "),
                              _c("p", [
                                _vm._v(
                                  "h:e:x: " +
                                    _vm._s(
                                      _vm._f("macStyleHex")(_vm.output_content)
                                    )
                                ),
                              ]),
                              _vm._v(" "),
                              _c("p", [
                                _vm._v(
                                  "base64: " +
                                    _vm._s(_vm._f("base64")(_vm.output_content))
                                ),
                              ]),
                            ]),
                          ]
                        ),
                      ])
                    : _vm._e(),
                ])
              : _vm._e(),
          ]
        ),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }